<template>
  <div>
    <el-dialog
      v-if="dialogVisible"
      :visible.sync="dialogVisible"
      title="设置学习视频"
      width="50%"
      :before-close="handleClose"
      :destroy-on-close="true"
      :close-on-click-modal="false"
    >
      <el-button
        size="medium"
        class="select_video_btn"
        type="primary"
        @click="handleCreate"
        >选择视频</el-button
      >
      <!-- 回显列表 -->
      <tableList
        :paperId="formData.id"
        @handleDelete="handleDeleteVideo"
        :videoIds="[]"
        ref="tableListRef"
      />
      <template #footer>
        <div class="flex" style="justify-content: center">
          <el-button @click="dialogVisible = false"> 关 闭</el-button>
        </div>
      </template>
    </el-dialog>
    <el-dialog
      v-if="dialogVisibleVideo"
      :visible.sync="dialogVisibleVideo"
      title="选择视频"
      width="50%"
      :before-close="handleCloseVideo"
      :destroy-on-close="true"
      :close-on-click-modal="false"
    >
      <!-- 选择视频 -->
      <tableList
        :isSelect="true"
        @selectionChange="selectionChange"
        :videoIds="videoIds"
        :classifyList="classifyList"
      />
      <template #footer>
        <div class="flex" style="justify-content: center">
          <el-button type="primary" @click="handleConfirmVideo">
            确 定
          </el-button>
          <el-button @click="handleCloseVideo"> 取 消 </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import { Message } from "element-ui";
import {
  questionTestView,
  questionTestUpdate,
  questionTestVideoDelete,
  questionTestVideoAdd,
} from "@/api/question/test";
import { videoListClassify } from "@/api/video/manage";

import tableList from "./tableList.vue";
import { mobilePhoneRule } from "@/utils/formRules";
import dayjs from "dayjs";
export default {
  name: "index",
  components: { tableList },

  data() {
    return {
      dialogVisible: false, // 弹窗的是否展示
      dialogTitle: "", // 弹窗的标题
      formLoading: false, // 表单的加载中：1）修改时的数据加载；2）提交的按钮禁用
      formType: "", // 表单的类型：create - 新增；update - 修改
      formData: {},
      videoIds: [], // 选择的视频id
      formRules: {
        // rebateCompleteRateState: [
        //   { required: true, message: "请输入", trigger: "blur" },
        // ],
      },
      classifyList: [], // 视频分类
      dialogVisibleVideo: false, // 选择视频弹窗
    };
  },
  created() {},
  methods: {
    /** 打开弹窗 */
    async open(id) {
      this.resetForm();
      this.dialogVisible = true;
      this.dialogTitle = "设置学习视频";

      // 修改时，设置数据
      console.log(id, "id222222222");
      this.formData.id = id;
      this.videoIds = [];
      this.formLoading = true;
      this.getVideoClassify();
      this.formLoading = false;
    },

    // 重置
    resetForm() {
      this.formData = {};
    },
    handleClose() {
      this.dialogVisible = false;
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
    },

    // 关闭选择视频
    handleCloseVideo() {
      this.dialogVisibleVideo = false;
    },
    // 确定选择视频
    async handleConfirmVideo() {
      // 校验表单

      try {
        this.formLoading = true;
        const params = {
          id: this.formData.id,
          videoIds: this.videoIds.map((item) => item.id),
        };
        const res = await questionTestVideoAdd(params);
        if (res.code == 200) {
          Message.success("修改成功");
          this.$refs.tableListRef.onLoad();
        }

        // 发送操作成功的事件
        this.$emit("success");
        this.formLoading = false;
      } catch (e) {
        // this.$message.error(e);
        this.formLoading = false;
      } finally {
      }
      this.dialogVisibleVideo = false;
    },
    // 删除视频
    handleDeleteVideo(row) {
      console.log(row, "row");

      questionTestVideoDelete(row.id).then((res) => {
        if (res.code == 200) {
          Message.success("删除成功");
          this.$refs.tableListRef.onLoad();
        }
      });
    },
    // 选择视频
    handleCreate() {
      this.dialogVisibleVideo = true;
    },
    // 接收选择的视频
    selectionChange(list) {
      console.log(list, "list");
      this.videoIds = list;
    },
    // 获取视频分类
    getVideoClassify() {
      videoListClassify().then((res) => {
        this.classifyList = res.data;
      });
    },
  },
};
</script>
<style scoped>
.video_box {
  margin-left: 3%;
  margin-bottom: 10px;
}
.video_icon {
  cursor: pointer;
  margin-top: 0.5%;
  margin-left: 10px;
}
.video_span {
  width: 80px;
  margin-left: 10px;
}
/deep/.el-input__inner {
  text-align: left;
}
.details_box {
  margin-right: 10%;
  max-width: 100%;
  overflow: hidden;
}
.select_video_btn {
  margin-bottom: 10px;
}
</style>
